import StorageClient, { LocalStorageKey } from 'lib/clients/StorageClient';

// These are commonly set on our homepage through Webflow.
// We additional set the UTM vars here to catch direct links to the signup flow.
const params = new URLSearchParams(window.location.search);
if (params.get('gclid')) {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  StorageClient.setLocalItem(LocalStorageKey.MarketingGclid, params.get('gclid'));
}

if (params.get('utm_source')) {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  StorageClient.setLocalItem(LocalStorageKey.MarketingUtmSource, params.get('utm_source'));
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  StorageClient.setLocalItem(LocalStorageKey.MarketingUtmCampaign, params.get('utm_campaign'));
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  StorageClient.setLocalItem(LocalStorageKey.MarketingUtmMedium, params.get('utm_medium'));
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  StorageClient.setLocalItem(LocalStorageKey.MarketingUtmTerm, params.get('utm_term'));
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  StorageClient.setLocalItem(LocalStorageKey.MarketingUtmContent, params.get('utm_content'));
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  StorageClient.setLocalItem(LocalStorageKey.MarketingUtmAudience, params.get('utm_audience'));
  StorageClient.setLocalItem(
    LocalStorageKey.MarketingUtmOther,
    JSON.stringify({
      // AWS Activate-specific parameter
      A3POPC: params.get('A3POPC'),
    }),
  );
} else if (params.get('ref')) {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  StorageClient.setLocalItem(LocalStorageKey.MarketingUtmSource, params.get('ref'));
  StorageClient.removeLocalItem(LocalStorageKey.MarketingUtmCampaign);
  StorageClient.removeLocalItem(LocalStorageKey.MarketingUtmMedium);
  StorageClient.removeLocalItem(LocalStorageKey.MarketingUtmTerm);
  StorageClient.removeLocalItem(LocalStorageKey.MarketingUtmContent);
  StorageClient.removeLocalItem(LocalStorageKey.MarketingUtmAudience);
  StorageClient.removeLocalItem(LocalStorageKey.MarketingUtmOther);
}
